populatePage();

function populatePage() {
  // Sort products alphabetically
  let product_list = document.querySelector('#cbd-legacy-product-list');
  if(product_list === null) {
    return;
  }
  
  [...product_list.children]
    .sort((a,b)=>a.querySelector(".cbd-legacy-product-title-text").innerHTML.toLowerCase()>b.querySelector(".cbd-legacy-product-title-text").innerHTML.toLowerCase()?1:-1)
    .forEach(node=>product_list.appendChild(node));
  
  Array.from(document.getElementsByClassName("cbd-legacy-test-list")).forEach(listElement => {
    [...Array.from(listElement.getElementsByClassName("cbd-legacy-test"))]
      .sort((a,b)=>a.querySelector(".cbd-legacy-lot-text").innerHTML<b.querySelector(".cbd-legacy-lot-text").innerHTML?1:-1)
      .forEach(node=>listElement.appendChild(node));
  });
}